import { useMemo } from "react";
import { Grid, GridItem, Heading, ScaleFade } from "@chakra-ui/react";
import DayConfig from "./DayConfig";

const DAY_TITLES = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export default function CalendarConfig( { calendar, allActivities, updateCalendar } ){
    const days = useMemo(() => {
        function makeActivities(activityList){
            const hydrated = []
            activityList.forEach((activity) => {
                const match = allActivities.find(a => a.id === activity.id)
                if(match){
                    hydrated.push(match)
                }
            })
            return hydrated
        }
        return DAY_TITLES.map((title) => (
            calendar[title]
                ? { title, activities: makeActivities(calendar[title]) }
                : { title }
        ))
    }, [calendar, allActivities])

    return(
        <ScaleFade initialScale={0.9} in>
        <Grid 
            gridTemplateColumns={'repeat(6, 1fr)'}
            border={'1px solid grey'}
            borderRadius={'lg'}
            minH='40vh'
        >
            {days.map((day) => (
                <GridItem 
                    key={`grid-item-${day.title}-${calendar.id}`}
                    border={'1px solid lightgrey'}
                    w='14vw' 
                    p='2'>
                    <Heading textAlign={'center'} mb='2' size='sm'>{day.title}</Heading>
                    <DayConfig 
                        day={day}
                        calendar={calendar}
                        allActivities={allActivities}
                        updateCalendar={updateCalendar}
                    />
                </GridItem>
            ))}
        </Grid>
        </ScaleFade>
    )
}
